import { createStyles } from 'antd-style';

export const useMetadataWidgetsStyles = createStyles(({ token }) => ({
  metadataInfo: {
    '.InlineLink': {
      display: 'inline-flex !important',
      color: token.colorPrimary,
      textDecoration: 'underline',
    },
  },
}));
